<template>
	<div>
		<transition name="router-fade" mode="fade-in">
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
    	</transition>
    	<transition name="router-fade" mode="fade-in">
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition>
		<svg-icon></svg-icon>
    </div>
</template>

<script>
	import svgIcon from './components/common/svg';
  	export default {
    	components:{
            svgIcon
		},
		data(){
			return{
				isLeftDrawer:true,
			}
		}
  	}

</script>

<style lang="scss">
	  @import './style/common.scss';
	//   @import './style/base.scss';
	//   @import './style/display.scss';
	//   @import './style/index.scss';

	.router-fade-enter-active, .router-fade-leave-active {
	  	transition: opacity .3s;
	}
	.router-fade-enter, .router-fade-leave-active {
	  	opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue